import { Component, ViewEncapsulation } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { InputsModule } from '../../inputs.module';
import { ISelectInput } from '../../interface';
import { BaseInputComponent } from '../base-input/base-input.component';
//https://github.com/Harvest-Dev/ng-select2/blob/master/src/app/app-examples.component.html
//https://harvest-dev.github.io/ng-select2/dist/ng-select2/browser/

@Component({
  selector: 'input-select',
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss',
  imports: [InputsModule, NgSelectModule],
  //changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class InputSelectComponent extends BaseInputComponent<ISelectInput> {
  itemsSnapshot: any[] = [];
  isFocused: boolean = false;
  constructor() {
    super();
  }
  override ngOnChanges(): void {
    super.ngOnChanges();
    if (this.options.searchable === undefined)
      this.options.searchable = true;
    this.options.items = this.options.items || [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' },
    ];
    this.itemsSnapshot = ([] as any).concat(this.options.items);
  }
}
